import * as React from 'react';
var MountElement = function (_a) {
    var node = _a.node, getParent = _a.getParent, selector = _a.selector;
    React.useLayoutEffect(function () {
        var parent = getParent(selector);
        parent.appendChild(node);
        return function () {
            parent.removeChild(node);
        };
    }, [node, selector, getParent]);
    return null;
};
export default MountElement;
